import classnames from 'classnames';

import styles from './NavBarBase.module.css';
import santaIwocaPayIconSrc from './santaIwocaPayIcon.png';
import { ReactComponent as IwocaPayIcon } from '../../svg/IwocaPayIcon.svg';

const IS_HOLIDAY_SEASON = false;
export const NavBarBase = ({
  className,
  children,
}: {
  children?: React.ReactNode;
  className?: string;
}) => {
  return (
    <>
      <div className={styles.navBarContainer}>
        <nav className={classnames(className, styles.navBar)}>
          <section className={styles.leftPane}>
            {IS_HOLIDAY_SEASON ? (
              <img
                src={santaIwocaPayIconSrc}
                className={styles.iwocaPayLogo}
                alt=""
              />
            ) : (
              <IwocaPayIcon className={styles.iwocaPayLogo} />
            )}
          </section>
          {children}
        </nav>
        <div className={styles.navBarPadding}></div>
      </div>
    </>
  );
};
